import { IContactService } from "./contact.types";
import { http } from '@/shared/https';

export class ContactService implements IContactService {
    getAllContact(): any {
        return http.get(`api/Common/Contacts`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }
}